<template lang="pug">
  .flooring-rolls
    Configuration(:buy-request="buyRequest.children[0]" :ignore-attributes="['flooring_length']" @update="update")
    hr
    flooring-calculator(:buy-request="buyRequest.children[0]" :rolls="rolls" @selected="selected")
    flooring-related-products(:group-meta="meta" :buy-requests="relatedProductBuyRequests")
</template>
<script>
import { useProductStore } from '@/js/stores/productStore'
import FlooringRelatedProducts from './related-products.vue'
import FlooringCalculator from './flooring-calculator.vue'
import { createBuyRequest, getBuyRequestMeta } from '../../../helpers/buy-request'
import ProductBadges from '../badges.vue'

export default {
  name       : 'FlooringRolls',
  components : { FlooringRelatedProducts, FlooringCalculator, ProductBadges },
  props      : {
    buyRequest: {
      type     : Object,
      required : true,
    },
  },
  data() {
    return {
      rolls                     : [],
      relatedProductBuyRequests : [],
      meta                      : {},
    }
  },
  async serverPrefetch() {
    await this.load()
  },
  async mounted() {
    await this.load()
  },
  watch: {
    relatedProductBuyRequests: {
      deep: true,
      handler() {
        this.buyRequest.children = [this.buyRequest.children[0], ...this.relatedProductBuyRequests]
      },
    },
    buyRequest: {
      deep      : true,
      immediate : true,
      handler() {
        this.meta = getBuyRequestMeta(this.buyRequest, this.$rogue)
      },
    },
  },
  setup() {
    const productStore = useProductStore()

    return { productStore }
  },
  computed: {
    products() {
      return this.productStore.products
    },
    configurable() {
      return this.products[this.buyRequest.children[0].productId]
    },
    product() {
      return this.products[this.buyRequest.productId]
    },
  },
  methods: {
    async load() {
      this.relatedProductBuyRequests = this.product.childrenIds.filter(id => id !== this.products[this.product.childrenIds[0]].productId)
        .map((id) => {
          const buyRequest = createBuyRequest({ ...this.products[id] }, this.$rogue)
          buyRequest.qty = 0
          buyRequest.sku = this.products[id].sku

          return buyRequest
        }).sort((b1, b2) => {
          const sku1 = this.products[b1.productId].sku
          const sku2 = this.products[b2.productId].sku
          if (sku1 === 'RG0009') {
            return -1
          }

          return sku2 === 'RG0009' ? 1 : 0
        })
      this.update()
    },
    update() {
      const selectedProduct = this.products[this.buyRequest.children[0].children[0].productId]
      const siblingProduct = Object.values(this.products).find((product) => product.attributes?.percentage === selectedProduct.attributes?.percentage
        && product.attributes?.regu_color === selectedProduct.attributes?.regu_color
        && product.attributes?.regu_type === selectedProduct.attributes?.regu_type
        && product.attributes?.flooring_length !== selectedProduct.attributes?.flooring_length)

      this.rolls = [selectedProduct, siblingProduct].filter(roll => !!roll)
    },
    selected(product) {
      const child = this.buyRequest.children[0]
      child.children[0].productId = product.productId
      child.qty = product.qty

      const tapeBuyRequest = this.relatedProductBuyRequests.find(br => this.products[br.productId].sku === 'RG0009')
      tapeBuyRequest.qty = product.RG0009
      this.buyRequest.children[0] = child
    },
  },
}
</script>
<style scoped lang="scss">
.flooring-rolls {
  hr {
    margin: $size-xs 0 ;
  }
}
</style>
